import { render, staticRenderFns } from "./EditProjectDialog.vue?vue&type=template&id=4d1a4deb&"
import script from "./EditProjectDialog.vue?vue&type=script&lang=js&"
export * from "./EditProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports